import { useState } from "react";
import { signInWithGoogle, SignInCancelledError } from "../lib/auth";
import { GoogleGIcon, LeafIcon } from "../components/icons";

export default function SignInScreen() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn() {
    setLoading(true);
    setError(null);
    try {
      await signInWithGoogle();
      // `signInWithGoogle` redirects the browser, so we usually won't hit
      // the next line. If we do (popup blocked, etc.), loading state stays.
    } catch (err) {
      if (err instanceof SignInCancelledError) {
        setError(null);
      } else {
        console.error(err);
        setError(
          err instanceof Error ? err.message : "Could not sign in"
        );
      }
      setLoading(false);
    }
  }

  return (
    <div className="app-shell sign-in">
      <div className="sign-in__middle">
        <div className="sign-in__logo">
          <LeafIcon size={44} color="#fff" />
        </div>
        <h1 className="sign-in__title">Sprig</h1>
        <p className="sign-in__tagline">
          Proactive plant care, one leaf at a time.
        </p>

        <button
          type="button"
          className="primary-btn sign-in__cta"
          onClick={handleSignIn}
          disabled={loading}
        >
          {!loading && <GoogleGIcon />}
          {loading ? "Opening Google…" : "Continue with Google"}
        </button>

        {error && <div className="sign-in__error">{error}</div>}
      </div>

      <p className="sign-in__footer">
        <em>"The best time to plant a tree was 20 years ago. The second best time is now."</em>
      </p>

      <style>{`
        .sign-in {
          padding-top: 48px;
          padding-bottom: 32px;
          min-height: 100vh;
        }
        .sign-in__middle {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          padding: 40px 0;
        }
        .sign-in__logo {
          width: 96px;
          height: 96px;
          border-radius: 24px;
          background: #2D7A4F;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 12px;
        }
        .sign-in__title {
          font-family: Georgia, serif;
          font-size: 36px;
          font-weight: 700;
          color: #1f5a39;
          margin: 0;
        }
        .sign-in__tagline {
          font-size: 13px;
          color: #6b7a6e;
          margin: 4px 0 28px 0;
          text-align: center;
        }
        .sign-in__cta {
          background: #fff;
          color: #1a2e22;
          border: 1px solid #dbe8df;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
        }
        .sign-in__error {
          margin-top: 12px;
          padding: 10px 14px;
          background: #fee2e2;
          color: #991b1b;
          border-radius: 12px;
          font-size: 13px;
        }
        .sign-in__footer {
          text-align: center;
          color: #6b7a6e;
          font-size: 12px;
          padding: 0 16px;
          margin: 0;
        }
      `}</style>
    </div>
  );
}
